export default function vanceCash(fetch, baseUrl) {
  return {
    getAllTransactions({ userId, page, pageSize }) {
      return fetch(
        `${baseUrl}/${userId}/vance-cash/transactions?page=${page}&page_size=${pageSize}`
      );
    },
    creditVanceCash({ amount, remarks, referenceType, userId }) {
      return fetch.put(`${baseUrl}/${userId}/update-user-wallet`, {
        amount,
        remarks,
        referenceType
      });
    },
    syncVanceCashWallet({ userId }) {
      return fetch.put(`${baseUrl}/${userId}/sync-wallet`);
    }
  };
}
